enum CurrencyCode {
  Empty = "",
  Usd = "USD",
  Cad = "CAD",
}

export { CurrencyCode };
